export const FORM_PERSISTENCE_STORAGE_PREFIX = 'form-persistence:'

export const getFormPersistenceStorageKey = (localStorageKey: string): string =>
  `${FORM_PERSISTENCE_STORAGE_PREFIX}${localStorageKey}`
